module.exports = __webpack_public_path__ + "static/media/nav-icon-impact-narrative-inactive.e0824b58.svg";